import { create } from "zustand";

interface ConfirmState {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  danger: boolean;
  onConfirm: () => void;
}

interface UiState {
  commandPaletteOpen: boolean;
  setCommandPaletteOpen: (v: boolean) => void;
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (v: boolean) => void;
  darkMode: "light" | "dark" | "system";
  setDarkMode: (v: "light" | "dark" | "system") => void;
  confirm: ConfirmState;
  showConfirm: (opts: {
    title: string;
    message: string;
    confirmLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
  }) => void;
  hideConfirm: () => void;
}

const defaultConfirm: ConfirmState = {
  open: false,
  title: "",
  message: "",
  confirmLabel: "Confirm",
  danger: false,
  onConfirm: () => {},
};

export const useUiStore = create<UiState>()((set) => ({
  commandPaletteOpen: false,
  setCommandPaletteOpen: (v) => set({ commandPaletteOpen: v }),
  sidebarCollapsed: false,
  setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
  darkMode: "system",
  setDarkMode: (v) => set({ darkMode: v }),
  confirm: defaultConfirm,
  showConfirm: (opts) =>
    set({
      confirm: {
        open: true,
        title: opts.title,
        message: opts.message,
        confirmLabel: opts.confirmLabel ?? "Confirm",
        danger: opts.danger ?? false,
        onConfirm: opts.onConfirm,
      },
    }),
  hideConfirm: () => set({ confirm: defaultConfirm }),
}));
